import React, { useState, useEffect, useRef } from 'react';
import { FaPlay, FaPause, FaVolumeUp, FaVolumeMute } from 'react-icons/fa';
import './Projects.css';

const Projects = () => {
  const [activeProject, setActiveProject] = useState(0);
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true);
  const [volume, setVolume] = useState(1);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const sectionRef = useRef(null);
  const videoRef = useRef(null);



  const projects = [
    {
      id: 1,
      title: 'יחסי ציבור ותקשורת למשרד עורכי דין',
      category: 'Public Relations',
      description: 'ניהול יחסי ציבור ותקשורת דיגיטלית למשרד עורכי דין עם דגש על מקצועיות ואמינות',
      results: ['הגדלת החשיפה ב-400%', 'הגדלת הלקוחות ב-250%', 'שיפור המוניטין'],
      mainImage: '/projects/lawyer-public-relations/lawyer-public-relations_2.jpeg',
      images: [
        '/projects/lawyer-public-relations/lawyer-public-relations_1.mp4',
        '/projects/lawyer-public-relations/lawyer-public-relations_3.jpeg',
        '/projects/lawyer-public-relations/lawyer-public-relations_4.jpeg',
        '/projects/lawyer-public-relations/lawyer-public-relations_5.jpeg',
        '/projects/lawyer-public-relations/lawyer-public-relations_6.jpeg',
      ],
      color: '#1a252f'
    },
    {
      id: 2,
      title: 'ניהול רשתות חברתיות לבר קוקטיילים',
      category: 'Social Media Management',
      description: 'יצירת תוכן ויזואלי מרהיב לבר קוקטיילים עם דגש על אווירה ואסתטיקה',
      results: ['400% עלייה בעוקבים', '200% עלייה בהזמנות', 'הגדלת המעורבות ב-350%'],
      mainImage: '/projects/cocktails/cocktails_1.jpeg',
      images: [
        '/projects/cocktails/cocktails_1.jpeg',
        '/projects/cocktails/cocktails_2.jpeg',
        '/projects/cocktails/cocktails_3.jpeg',
        '/projects/cocktails/cocktails_4.jpeg'
      ],
      color: '#ff6b9d'
    },
    {
      id: 3,
      title: 'ניהול רשתות חברתיות לקונדיטוריה בוטיק',
      category: 'Social Media Management',
      description: 'ניהול מלא של הרשתות החברתיות עם דגש על תוכן ויזואלי מפתה וצילומי מוצרים מקצועיים',
      results: ['300% עלייה בעוקבים', '150% עלייה בהזמנות', 'הגדלת המעורבות ב-400%'],
      mainImage: '/projects/cakes/cakes_1.jpeg',
      images: [
        '/projects/cakes/cakes_1.jpeg',
        '/projects/cakes/cakes_2.jpeg',
        '/projects/cakes/cakes_3.jpeg',
        '/projects/cakes/cakes_4.jpeg',
      ],
      color: '#d4af37'
    },
    {
      id: 4,
      title: 'ניהול רשתות חברתיות לוילה יוקרתית',
      category: 'Social Media Management', 
      description: 'תוכן ויזואלי מקצועי לוילה יוקרתית עם דגש על חוויית אירוח מושלמת',
      results: ['400% עלייה בחשיפה', '300% עלייה בהזמנות', 'דירוג 5 כוכבים'],
      mainImage: '/projects/villa2/villa2_1.jpeg',
      images: [
        '/projects/villa2/villa2_1.jpeg',
        '/projects/villa2/villa2_2.jpeg'
      ],
      color: '#43e97b'
    },
    {
      id: 5,
      title: 'קמפיין דיגיטלי לאימון כושר אישי',
      category: 'Digital Campaign',
      description: 'בניית קמפיין דיגיטלי מקיף למאמן כושר אישי עם דגש על השראה ומוטיבציה',
      results: ['500% עלייה בחשיפה', '300% עלייה בלקוחות', 'הגעה ל-2M צפיות'],
      mainImage: '/projects/fitness/fitness_1.jpeg',
      images: [
        '/projects/fitness/fitness_1.jpeg',
        '/projects/fitness/fitness_2.jpeg',
        '/projects/fitness/fitness_3.jpeg',
        '/projects/fitness/fitness_4.jpeg',
        '/projects/fitness/fitness_5.jpeg',
        '/projects/fitness/fitness_6.jpeg',
        '/projects/fitness/fitness_7.jpeg',
        '/projects/fitness/fitness_8.jpeg',
        '/projects/fitness/fitness_9.jpeg',
        '/projects/fitness/fitness_10.jpeg'
      ],
      color: '#4ecdc4'
    },
    {
      id: 6,
      title: 'ניהול תוכן דיגיטלי למשרד עורכי דין',
      category: 'Digital Management',
      description: 'ניהול תוכן דיגיטלי מקצועי למשרד עורכי דין עם דגש על אמינות ומקצועיות',
      results: ['הגדלת המעורבות ב-250%', 'הגדלת הלקוחות ב-180%', 'שיפור התדמית המקצועית'],
      mainImage: '/projects/lawyer-digital-mng/lawyer-digital-mng_5.jpeg',
      images: [
        '/projects/lawyer-digital-mng/lawyer-digital-mng_5.jpeg',
        '/projects/lawyer-digital-mng/lawyer-digital-mng_2.jpeg',
        '/projects/lawyer-digital-mng/lawyer-digital-mng_3.jpeg',
        '/projects/lawyer-digital-mng/lawyer-digital-mng_4.jpeg',
        '/projects/lawyer-digital-mng/lawyer-digital-mng_1.jpeg',
        '/projects/lawyer-digital-mng/lawyer-digital-mng_9.jpeg',
        '/projects/lawyer-digital-mng/lawyer-digital-mng_10.jpeg',
        '/projects/lawyer-digital-mng/lawyer-digital-mng_11.jpeg'
      ],
      color: '#34495e'
    },
    {
      id: 7,
      title: 'ניהול רשתות חברתיות לגלידרייה בוטיק',
      category: 'Social Media Management',
      description: 'יצירת תוכן ויזואלי מפתה וצבעוני לגלידרייה בוטיק עם דגש על מוצרים ייחודיים ואווירה מזמינה',
      results: ['350% עלייה בעוקבים', '200% עלייה במכירות', 'הגדלת המעורבות ב-450%'],
      mainImage: '/projects/ice-cream-botique/ice-cream-botique_1.jpeg',
      images: [
        '/projects/ice-cream-botique/ice-cream-botique_1.jpeg',
        '/projects/ice-cream-botique/ice-cream-botique_2.jpeg',
        '/projects/ice-cream-botique/ice-cream-botique_3.jpeg',
        '/projects/ice-cream-botique/ice-cream-botique_4.jpeg',
        '/projects/ice-cream-botique/ice-cream-botique_5.jpeg',
        '/projects/ice-cream-botique/ice-cream-botique_6.jpeg',
        '/projects/ice-cream-botique/ice-cream-botique_7.jpeg'
      ],
      color: '#87ceeb'
    },
    {
      id: 8,
      title: 'ניהול רשתות חברתיות לוילה להשכרה',
      category: 'Social Media Management',
      description: 'יצירת תוכן מרהיב לוילה להשכרה עם דגש על יופי ונוחות',
      results: ['300% עלייה בפניות', '250% עלייה בהזמנות', 'הגדלת המעורבות ב-400%'],
      mainImage: '/projects/villa1/villa_1.jpeg',
      images: [
        '/projects/villa1/villa_1.jpeg',
        '/projects/villa1/villa_2.jpeg'
      ],
      color: '#e67e22'
    },
    {
      id: 9,
      title: 'ניהול רשתות חברתיות למסעדות!',
      category: 'Social Media Management',
      description: 'יצירת תוכן קולינרי מפתה ומקצועי למסעדות עם דגש על הצגת המנות והאווירה הייחודית',
      results: ['250% עלייה בעוקבים', '180% עלייה בהזמנות', 'הגדלת המעורבות ב-320%'],
      mainImage: '/projects/food/food_1.jpeg',
      images: [
        '/projects/food/food_1.jpeg',
        '/projects/food/food_2.jpeg',
        '/projects/food/food_3.jpeg',
        '/projects/food/food_4.jpeg',
        '/projects/food/food_6.jpeg'
      ],
      color: '#e74c3c'
    },
    {
      id: 10,
      title: 'ניהול אישי ובניית תדמית למשרד עורכי דין',
      category: 'Personal Management',
      description: 'ניהול אישי ובניית תדמית אישית ומקצועית לעורכי דין עם דגש על מקצועיות',
      results: ['הגדלת המעורבות ב-300%', 'הגדלת הלקוחות ב-200%', 'שיפור התדמית האישית'],
      mainImage: '/projects/lawyer-personal/lawyer-personal_1.jpeg',
      images: [
        '/projects/lawyer-personal/lawyer-personal_1.jpeg',
        '/projects/lawyer-personal/lawyer-personal_2.jpeg',
        '/projects/lawyer-personal/lawyer-personal_3.jpeg',
        '/projects/lawyer-personal/lawyer-personal_4.jpeg',
        '/projects/lawyer-personal/lawyer-personal_5.jpeg',
        '/projects/lawyer-personal/lawyer-personal_6.jpeg'
      ],
      color: '#2c3e50'
    },
    {
      id: 11,
      title: 'הזמנות Save The Date',
      category: 'Event Design',
      description: 'עיצוב הזמנות Save The Date מרהיבות לחתונות ואירועים מיוחדים עם דגש על רגע קסום ומזכרת מיוחדת',
      results: ['עיצוב 50+ הזמנות', 'עיצובים ייחודיים ואישיים', '100% שביעות רצון מזוגות מאושרים'],
      mainImage: '/projects/save-the-date/save-the-date_1.jpeg',
      images: [
        '/projects/save-the-date/save-the-date_1.jpeg',
        '/projects/save-the-date/save-the-date_2.jpeg',
        '/projects/save-the-date/save-the-date_3.jpeg',
        '/projects/save-the-date/save-the-date_4.jpeg',
        '/projects/save-the-date/save-the-date_5.jpeg',
      ],
      color: '#c9a96e'
    },
    {
      id: 12,
      title: 'עיצוב תפריטים ופרסומות',
      category: 'Graphic Design',
      description: 'עיצוב תפריטים ופרסומות מרהיבים עם דגש על יופי, אלגנטיות ומסרים שיווקיים מושכים',
      results: ['עיצוב 40+ פרויקטים', '100% שביעות רצון לקוחות', 'תפריטים ופרסומות ייחודיים ומותאמים אישית'],
      mainImage: '/projects/menus/menus_1.jpeg',
      images: [
        '/projects/menus/menus_1.jpeg',
        '/projects/menus/menus_2.jpeg',
        '/projects/menus/menus_3.jpeg',
        '/projects/menus/menus_4.jpeg'
      ],
      color: '#ff69b4'
    },
    {
      id: 13,
      title: 'עיצוב גרפי ומיתוג מתקדם',
      category: 'Graphic Design',
      description: 'עיצוב גרפי מקצועי ומיתוג עסקי עם דגש על זהות ויזואלית חזקה ומודרנית',
      results: ['עיצוב 25+ פרויקטים', '100% שביעות רצון לקוחות', 'זכייה בתחרות עיצוב'],
      mainImage: '/projects/graphic-design/graphic-design_1.jpeg',
      images: [
        '/projects/graphic-design/graphic-design_1.jpeg',
        '/projects/graphic-design/graphic-design_2.jpeg',
        '/projects/graphic-design/graphic-design_3.jpeg',
        '/projects/graphic-design/graphic-design_4.jpeg',
        '/projects/graphic-design/graphic-design_7.jpeg'
      ],
      color: '#9b59b6'
    }
  ];

  useEffect(() => {
    // This effect handles the intersection observer for fade-in animations
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);




  const nextProject = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setActiveProject((prev) => (prev + 1) % projects.length);
    setActiveImageIndex(0); // Reset to first image when changing projects
  };


  const handleLeftSideClick = () => {
    // Left side click - next image/project
    const currentProject = projects[activeProject];
    const nextImageIndex = activeImageIndex + 1;
    
    if (nextImageIndex < currentProject.images.length) {
      // Show next image in current project
      setActiveImageIndex(nextImageIndex);
    } else {
      // Go to next project and reset to first image
      nextProject();
    }
  };

  const handleRightSideClick = () => {
    // Right side click - previous image/project
    const prevImageIndex = activeImageIndex - 1;
    
    if (prevImageIndex >= 0) {
      // Show previous image in current project
      setActiveImageIndex(prevImageIndex);
    } else {
      // Go to previous project and set to last image
      const newProjectIndex = activeProject - 1 >= 0 ? activeProject - 1 : projects.length - 1;
      setActiveProject(newProjectIndex);
      setActiveImageIndex(projects[newProjectIndex].images.length - 1);
    }
  };

  const handlePhoneContextMenu = (e) => {
    e.preventDefault(); // Prevent context menu on right-click
  };

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    if (videoRef.current) {
      videoRef.current.volume = newVolume;
      if (newVolume === 0) {
        setIsMuted(true);
        videoRef.current.muted = true;
      } else if (isMuted) {
        setIsMuted(false);
        videoRef.current.muted = false;
      }
    }
  };

  const handleTimeUpdate = () => {
    if (videoRef.current) {
      setCurrentTime(videoRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (videoRef.current) {
      setDuration(videoRef.current.duration);
    }
  };

  const handleSeek = (e) => {
    const newTime = parseFloat(e.target.value);
    setCurrentTime(newTime);
    if (videoRef.current) {
      videoRef.current.currentTime = newTime;
    }
  };

  const formatTime = (seconds) => {
    if (isNaN(seconds)) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };

  useEffect(() => {
    // Reset video state when changing images
    setIsMuted(true);
    setCurrentTime(0);
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.muted = true;
      videoRef.current.play().then(() => {
        setIsPlaying(true);
      }).catch(() => {
        setIsPlaying(false);
      });
    } else {
      setIsPlaying(false);
    }
  }, [activeImageIndex, activeProject]);


  const closeImageModal = () => {
    setIsImageModalOpen(false);
  };

  // Close modal on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        closeImageModal();
      }
    };

    if (isImageModalOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isImageModalOpen]);

  return (
    <section id="projects" className="projects section" ref={sectionRef}>
      <div className="container">

        {/* Instagram Stories Style Projects */}
        <div className={`projects-showcase ${isVisible ? 'slide-in-left' : ''}`}>
          <div className="projects-header">
            <h2 className="heading-lg">
              <span className="gradient-text">פרויקטים נבחרים</span>
            </h2>
            <p className="text-lg">
              כל פרויקט הוא סיפור של הצלחה, יצירתיות ותוצאות מדהימות
            </p>
          </div>

          {/* New Layout: Description + Phone + Circular Selection */}
          <div className="projects-layout">
            
            {/* Circular Project Selection */}
            <div className="circular-selection">
              {projects.map((project, projectIndex) => (
                <div
                  key={projectIndex}
                  className={`project-circle ${projectIndex === activeProject ? 'active' : ''}`}
                  onClick={() => {
                    setActiveProject(projectIndex);
                    setActiveImageIndex(0); // Always go to first image when selecting a project
                  }}
                >
                  <div className="circle-content">
                    <img src={project.mainImage} alt={project.title} />
                  </div>
                  {/* Image indicators for each project */}
                  <div className="image-indicators">
                    {project.images.map((_, imageIndex) => (
                      <div
                        key={imageIndex}
                        className={`indicator-line ${
                          projectIndex === activeProject && imageIndex === activeImageIndex 
                            ? 'active' 
                            : projectIndex === activeProject && imageIndex < activeImageIndex
                            ? 'completed'
                            : ''
                        }`}
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="main-content">
              {/* Project Description - Left Column */}
              <div className="project-description-column">
                <div className="project-category">
                  {projects[activeProject].category}
                </div>
                
                <h3 className="project-title">
                  {projects[activeProject].title}
                </h3>
                
                <p className="project-description">
                  {projects[activeProject].description}
                </p>
                
                <div className="project-results">
                  <h4 className="results-title">תוצאות מדהימות!!</h4>
                  <ul className="results-list">
                    {projects[activeProject].results.map((result, index) => (
                      <li key={index} className="result-item">
                        <span className="result-bullet">✓</span>
                        {result}
                      </li>
                    ))}
                  </ul>
                </div>

              </div>

              {/* Phone Frame - Right Column */}
              <div className="phone-column">
                <div className="phone-frame">
                  {/* Story Content */}
                  <div 
                    className="story-content" 
                    onContextMenu={handlePhoneContextMenu}
                  >
                    {projects[activeProject].images[activeImageIndex].endsWith('.mp4') ? (
                      <>
                        <video 
                          ref={videoRef}
                          src={projects[activeProject].images[activeImageIndex]} 
                          className="story-image"
                          playsInline
                          muted
                          autoPlay
                          onTimeUpdate={handleTimeUpdate}
                          onLoadedMetadata={handleLoadedMetadata}
                          onPlay={() => setIsPlaying(true)}
                          onPause={() => setIsPlaying(false)}
                        />
                        
                        {/* Custom Video Controls */}
                        <div className="video-controls-bar">
                          <div className="video-progress-container">
                            <input
                              type="range"
                              min="0"
                              max={duration || 0}
                              value={currentTime}
                              onChange={handleSeek}
                              className="video-progress-slider"
                            />
                          </div>
                          
                          <div className="video-controls-bottom">
                            <button className="video-control-btn" onClick={togglePlay}>
                              {isPlaying ? <FaPause /> : <FaPlay />}
                            </button>
                            
                            <span className="video-time">
                              {formatTime(currentTime)} / {formatTime(duration)}
                            </span>
                            
                            <div className="video-volume-control">
                              <button className="video-control-btn" onClick={toggleMute}>
                                {isMuted || volume === 0 ? <FaVolumeMute /> : <FaVolumeUp />}
                              </button>
                              <input
                                type="range"
                                min="0"
                                max="1"
                                step="0.1"
                                value={isMuted ? 0 : volume}
                                onChange={handleVolumeChange}
                                className="video-volume-slider"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <img 
                        src={projects[activeProject].images[activeImageIndex]} 
                        alt={projects[activeProject].title}
                        className="story-image"
                      />
                    )}
                    
                    {/* Image counter overlay */}
                    <div className="image-counter">
                      {activeImageIndex + 1} / {projects[activeProject].images.length}
                    </div>

                    {/* Invisible click zones - always active */}
                    <div className="click-zone left-zone" onClick={handleLeftSideClick} />
                    <div className="click-zone right-zone" onClick={handleRightSideClick} />
                  </div>
                </div>
                
                <p className="phone-instruction">
                  צד שמאל: תמונה הבאה → | צד ימין: תמונה קודמת ←
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Image Modal */}
      {isImageModalOpen && (
        <div className="image-modal" onClick={closeImageModal}>
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeImageModal}>
              ×
            </button>
            {projects[activeProject].images[activeImageIndex].endsWith('.mp4') ? (
              <video 
                src={projects[activeProject].images[activeImageIndex]} 
                className="modal-image"
                playsInline
                controls
              />
            ) : (
              <img 
                src={projects[activeProject].images[activeImageIndex]} 
                alt={projects[activeProject].title}
                className="modal-image"
              />
            )}
            <div className="modal-info">
              <h4>{projects[activeProject].title}</h4>
              <p>תמונה {activeImageIndex + 1} מתוך {projects[activeProject].images.length}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Projects;